import React from 'react'
import PropTypes from 'prop-types'

import Image from './Image'
import Gallery from './Gallery'
import Quote from './Quote'
import Text from './Text'
import Employee from './Employee'
import Wysiwyg from './Wysiwyg'
import JournalExcerpt from './JournalExcerpt'
import Nav from 'components/Page/Nav'

import './content.css'

const Content = (props) => getComponents(props.data)

const getComponents = (data, columnClass) => {
  const components = data.map((component, idx) => {
    switch (component.type) {
      case 'columns':
        if (Array.isArray(component.columns[0])) {
          const components = component.columns.map((column, idx) => (
            <div key={idx} className='col-xs-12 col-sm-6'>
              {getComponents(column)}
            </div>
          ))
          return (
            <div key={idx} className='content--two-col'>
              <div className='row'>
                {components}
              </div>
            </div>
          )
        } else if (component.columns.length === 1) {
          return (
            <div key={idx} className='content-wrapper content row'>
              {getComponents(component.columns, 'col-xs-12 col-sm-12')}
            </div>
          )
        } else {
          return (
            <div key={idx} className='content-wrapper content row'>
              {getComponents(component.columns, 'col-xs-12 col-sm-6')}
            </div>
          )
        }
      case 'text':
        return (
          <Text
            key={idx}
            {...component}
          />
        )
      case 'wysiwyg':
        return (
          <Wysiwyg
            key={idx}
            content={component.content}
          />
        )
      case 'nav':
        return (
          <Nav
            key={idx}
            {...component}
          />
        )
      case 'quote':
        return (
          <Quote
            key={idx}
            className={columnClass}
            title={component.title}
            name={component.name}
            position={component.position}
          />
        )
      case 'image':
        return (
          <Image
            key={idx}
            className={columnClass}
            width={component.width}
            src={component.src}
            alt={component.alt}
          />
        )
      case 'gallery':
        return (
          <Gallery
            key={idx}
            useMobileCarousel={component.useMobileCarousel}
            images={component.images}
          />
        )
      case 'employee':
        return (
          <Employee
            key={idx}
            className={columnClass}
            {...component}
          />
        )
      case 'new-employee':
        return (
          <Employee
            key={idx}
            className={columnClass}
            new
          />
        )
      case 'journal-excerpt':
        return (
          <JournalExcerpt
            key={idx}
            {...component}
          />
        )
      default:
        return ''
    }
  })

  return components
}

Content.propTypes = {
  data: PropTypes.array.isRequired
}

export default Content



// WEBPACK FOOTER //
// ./src/components/Page/Content/index.js